import { Title, TitleProps } from '@mantine/core';

type Props = TitleProps;

function Subtitle2(props: Props) {
  return <Title fz={14} fs="normal" fw={600} {...props} />;
}

export default Subtitle2;
